/***************************************************************************************************
 * Loaded before the app. The app runs zoneless, so nothing patches the browser
 * here any more; what is left are two globals that third-party bundles expect
 * to find on window.
 */
(window as { global?: unknown }).global = (window as { global?: unknown }).global || window;
(window as { process?: unknown }).process = (window as { process?: unknown }).process || { env: { NODE_ENV: 'staging' } };
